import { render, staticRenderFns } from "./abnormal-create-page.html?vue&type=template&id=94df177a&"
import script from "./abnormal-create-page.ts?vue&type=script&lang=ts&"
export * from "./abnormal-create-page.ts?vue&type=script&lang=ts&"
import style0 from "./abnormal-create-page.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports